import { render, staticRenderFns } from "./player.vue?vue&type=template&id=9aac866c&scoped=true"
import script from "./player.vue?vue&type=script&lang=js"
export * from "./player.vue?vue&type=script&lang=js"
import style0 from "./player.vue?vue&type=style&index=0&id=9aac866c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aac866c",
  null
  
)

export default component.exports